/* eslint-disable no-duplicate-case */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable default-case */
import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {useStore} from '../../../../../store/store';
import {toast} from 'react-toastify';
import {useParams} from 'react-router-dom';
import Stream from './Stream';
import Settings from './Settings';

import PageWrapper from '../../../../modules/PageWrapper';
import Analyze from './Analyze';

import Header from './Header';

const CompanyWrapper = () => {
  const {id} = useParams();

  const [timeConfig, setTimeConfig] = useState({});
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);

  return (
    <PageWrapper
      prevTimeConfig={prevTimeConfig}
      allowAllTimes
      firstTimeConfig='current_month'
      breadcrumbs={[
        {title: 'Трекер', path: ``},
        {isSeparator: true},
        {title: 'Facebook', path: ``},
        {isSeparator: true},
        {
          title: `Кампания #${id}`,
          path: `/`,
        },
      ]}
      title={`Кампания #${id}`}
    >
      <Company id={id} setPrevTimeConfig={setPrevTimeConfig} prevTimeConfig={prevTimeConfig} />
    </PageWrapper>
  );
};

export const Company = observer(
  ({
    timeConfig,
    isVerify,
    setPreloader,
    id,
    setPrevTimeConfig,
    prevTimeConfig,
    CalendarForFullScreen,
  }) => {
    const store = useStore();
    const [page, setPage] = useState('stream');
    const [data, setData] = useState({});

    const [saveButtonState, setSaveButtonState] = useState(0);
    const [settingData, setSettingData] = useState({});
    const [settingValidation, setSettingValidation] = useState({});

    useEffect(() => {
      isVerify && timeConfig.time_config && getData();
    }, [timeConfig, isVerify]);

    const getData = async () => {
      const tc = timeConfig;
      const [getTrafficStats, getRomiList] = await Promise.all([
        store.requestGet(`traffics/facebook/campaign/${id}`, {
          params: timeConfig,
        }),
        store.requestGet('Finance/Category/getRomiList'),
      ]);
      const romi = Math.round(+getTrafficStats.romi);
      const indicator = getRomiList.find((el) => el.romi_min <= romi && el.romi_max >= romi);

      setData({...getTrafficStats, indicator});
      setSettingData({
        name: getTrafficStats?.name,
        avatar: getTrafficStats?.avatar,
        source_link: getTrafficStats?.source_link,
      });
      setPreloader(false);
    };

    const saveSetting = async () => {
      if (Object.values(settingValidation).some(Boolean)) return;

      const formData = new FormData();
      for (const [key, value] of Object.entries(settingData)) {
        if (key === 'avatar') {
          if (!!value.length) {
            formData.append(`${key}`, value[0]);
            continue;
          }
          continue;
        }
        formData.append(`${key}`, value || '');
      }

      const result = await store.requestPatch(
        `traffics/facebook/campaign/${id}?token=${store?.user?.main_token}`,
        {
          data: formData,
          preloader: false,
        }
      );

      if (!!result) {
        setData((prev) => ({...prev, ...result}));
        toast.success(`Успешно обновлено!`, {});
      }

      !result &&
        toast.error(`Произошла ошибка в обновлении!`, {
          theme: 'colored',
        });
    };

    return (
      <>
        <Header
          page={page}
          setPage={setPage}
          data={data}
          id={id}
          settingData={settingData}
          setSettingData={setSettingData}
          saveSetting={saveSetting}
          saveButtonState={saveButtonState}
          setSaveButtonState={setSaveButtonState}
        />
        {page === 'stream' && (
          <Stream
            id={id}
            setPrevTimeConfig={setPrevTimeConfig}
            prevTimeConfig={prevTimeConfig}
            timeConfig={timeConfig}
            isVerify={isVerify}
            setPreloader={setPreloader}
            CalendarForFullScreen={CalendarForFullScreen}
          />
        )}
        {page === 'settings' && (
          <Settings
            setSettingData={setSettingData}
            settingData={settingData}
            settingValidation={settingValidation}
            setSettingValidation={setSettingValidation}
            saveButtonState={saveButtonState}
            setSaveButtonState={setSaveButtonState}
          />
        )}
        {page === 'analiz' && <Analyze id={id} tc={timeConfig} />}
      </>
    );
  }
);

export default CompanyWrapper;
